module.exports = __webpack_public_path__ + "static/media/Innovation_Programmes.0d1dc853.jpg";